var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[(parseInt(_vm.quantity) > 1)?_c('div',{staticClass:"chip"},[_vm._v("x "+_vm._s(_vm.quantity))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }